import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import editUserServices from '../../services/edit-users/edit-users.service';
import { OtherUserModel } from '../../models/all-user/edit-user-model';
import AppLoading from '../app-loading/app-loading';
import ComplaintService from "../../services/complaintStatus/status";
import StatusSearch from './status-search';
import StatusDatable from './status-datatable';

const ViewStatus: React.FC = () => {
    
    const { t } = useTranslation();
    const [userList, setUserList] = useState<OtherUserModel[]>([]);
    const [refreshPage, setRefreshPage] = useState(true);
    const [loading, setLoading] = useState(false);
    const [selectedKeyword, setSelectedKeyword] = useState<string>('');
    const [complaintStatuses, setComplaintStatuses] = useState<any[]>([]);
    const [filteredComplaintStatuses, setFilteredComplaintStatuses] = useState<any[]>([]); 


    useEffect(() => {
        fetchComplaintStatuses(); 
      }, []);
    
    useEffect(() => {           
        handleSearch(selectedKeyword);
    }, [selectedKeyword]);

    const fetchComplaintStatuses = async () => {
        try {
          const response = await ComplaintService.getAllStatus();
          setComplaintStatuses(response);
          setFilteredComplaintStatuses(response); 
        } catch (error) {
          console.error('Error fetching Statuses:', error);
        }
      };

      // const handleSearch = (keyword: string) => {
      //   setSelectedKeyword(keyword); 
      //   const filteredStatuses = complaintStatuses.filter((status: any) =>
      //     status.complaintName.toLowerCase().includes(keyword.toLowerCase())
      //   );
      //   setFilteredComplaintStatuses(filteredStatuses); 
      // };

      // const handleSearch = (keyword: string) => {
       
      //   setSelectedKeyword(keyword);
      //   const filteredStatuses = complaintStatuses.filter((status: any) =>
      //     (status.name || '').toLowerCase().includes((keyword || '').toLowerCase())
      //   );
           
      //   setFilteredComplaintStatuses(filteredStatuses);
      // };
      
      const handleSearch = (searchText: string) => {
        const keywords = searchText.toLowerCase().trim().split(/\s+/);
      
        const filteredStatuses = complaintStatuses.filter((status) => {
          const itemText = Object.values(status)
            .join(" ")
            .toLowerCase();
      
          return keywords.every((word) => itemText.includes(word));
        });
      
        setFilteredComplaintStatuses(filteredStatuses);
      };
      

    const reloadPage = (val:boolean)=>{
        setRefreshPage(val)
    } 
    
    return (
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">                
                <h4 className="ml-1 mb-0">{t('edit_complaintstatus_head')}</h4>
            </div>
            <StatusSearch onSearch={setSelectedKeyword}/>
            <StatusDatable complaintStatus={filteredComplaintStatuses} />
        </div>
    );
};

export default ViewStatus;